/**
 * Utilitário para combinar classes CSS
 * 
 * @author Equipe GestaoeCRM
 * @date 25/09/2025
 */

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
